export default __webpack_public_path__ + "static/media/cross.a0d940aa.svg";